/**
 * Адаптер для преобразования объекта апи аттачмент в объект типа файл.
 * (для работы с компонентой AttachmentFile)
 * @type {{
 *   toFile(attachment: Object | null): {uid: string, name: string} | null
 * }}
 */
const ApiAttachmentFileAdapter = {
  toFile(attachment) {
    if (null === attachment) {
      return null;
    }

    return {
      uid: attachment.uid,
      name: attachment.filename,
    };
  },
};

export { ApiAttachmentFileAdapter };
